import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";
import OperatorProjectWorkspaceApi from "./operatorProjectWorkspaceApi";
import { normalizePartnerReferralFilterApiResponse } from "../utils/partnerReferralFilterApi";

const createCustomerWithoutRequestLeadApi = (base) => ({
  getPagedList: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetPagedList?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getDetail: async (userId) => {
    const response = await api.request({
      url: `${base}/GetDetail?${queryString.stringify({ userId })}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getReasonOptions: async () => {
    const response = await api.request({
      url: `${base}/GetReasonOptions`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getOperators: async () => {
    const response = await api.request({
      url: `${base}/GetOperators`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getStats: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetStats?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getPartnerReferralFilterOptions: async () => {
    try {
      const response = await api.request({
        url: `${base}/GetPartnerReferralFilterOptions`,
        method: "GET",
        headers: authHeader(),
      });
      const normalized = normalizePartnerReferralFilterApiResponse(response.data);
      if (normalized.isSuccess && normalized.data.length > 0) {
        return normalized;
      }
    } catch {
      // Older API builds may not expose this action yet.
    }

    return OperatorProjectWorkspaceApi.getPartnerReferralFilterOptions();
  },

  updateLead: async (data) => {
    const response = await api.request({
      url: `${base}/UpdateLead`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  addFollowUp: async (data) => {
    const response = await api.request({
      url: `${base}/AddFollowUp`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  sendSubmitRequestNudgeSms: async (data) => {
    const response = await api.request({
      url: `${base}/SendSubmitRequestNudgeSms`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },
});

const CustomerWithoutRequestLeadApi = createCustomerWithoutRequestLeadApi(
  "SLN/Management/CustomerWithoutRequestLead"
);

export const customerWithoutRequestLeadOperatorApi = createCustomerWithoutRequestLeadApi(
  "SLN/SolarentOperator/CustomerWithoutRequestLead"
);

export default CustomerWithoutRequestLeadApi;
